/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MedBriefcaseIcon16Light } from './MedBriefcaseIcon16Light';
import { MedBriefcaseIcon16Regular } from './MedBriefcaseIcon16Regular';
import { MedBriefcaseIcon16Solid } from './MedBriefcaseIcon16Solid';
import { MedBriefcaseIcon20Light } from './MedBriefcaseIcon20Light';
import { MedBriefcaseIcon20Regular } from './MedBriefcaseIcon20Regular';
import { MedBriefcaseIcon20Solid } from './MedBriefcaseIcon20Solid';
import { MedBriefcaseIcon24Regular } from './MedBriefcaseIcon24Regular';
import { MedBriefcaseIcon24Solid } from './MedBriefcaseIcon24Solid';
import { MedBriefcaseIcon32Regular } from './MedBriefcaseIcon32Regular';
import { MedBriefcaseIcon64Regular } from './MedBriefcaseIcon64Regular';
var sizes = {
    16: {
        light: MedBriefcaseIcon16Light,
        regular: MedBriefcaseIcon16Regular,
        solid: MedBriefcaseIcon16Solid,
    },
    20: {
        light: MedBriefcaseIcon20Light,
        regular: MedBriefcaseIcon20Regular,
        solid: MedBriefcaseIcon20Solid,
    },
    24: {
        regular: MedBriefcaseIcon24Regular,
        solid: MedBriefcaseIcon24Solid,
    },
    32: {
        regular: MedBriefcaseIcon32Regular,
    },
    64: {
        regular: MedBriefcaseIcon64Regular,
    },
};
export var MedBriefcaseIcon = forwardRef('MedBriefcaseIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
